goog.provide('el8.ptdata.model.note.checklistSet');

goog.require('el8.data.model.checklist');
goog.require('el8.ptdata.model.note.editableSet');


(function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8.data.model.checklist);
    _class.addIntProperty("noteId");
    _class.addIntProperty("editId", true);
    _class.addIntProperty("replacedByEditId", true);

    el8.ptdata.model.note.checklist = function(spec) { return new _class(spec); };

})();

// ---------------------
// * VISIT NOTE CHECKLISTS *
// ---------------------
el8.ptdata.model.note.checklistSet = function(_noteId, _data) {

    var _set = new el8.ptdata.model.note.editableSet({
        model: function(spec) {
            if (!spec.noteId) { spec.noteId = _noteId || null; }
            return el8.ptdata.model.note.checklist(spec);
        }
    });
    _set.getByReplacedByEditId = function(editId) {
        var all = _set.all(true);
        for (var i=0; i<all.length; i++) {
            if (all[i].getReplacedByEditId() === editId) {
                return all[i];
            }
        }
        return null;
    };

    _set.create(_data);
    return _set;

};



